import ButtonWithIcon from "../../atoms/buttons/buttonWithIcon/ButtonWithIcon";
import CTAButton from "../../atoms/CTAButton/CTAButton";
import { CustomContainer } from "../../atoms/DependencyHelper";
import OTPInput from "../otpInput/OtpInput";
import styles from "./OtpComponent.module.scss";
import { useState } from "react";
import config from "../../../config/index";

const OtpComponent = ({
  title,
  otpValue,
  otpHandler,
  primaryButtonText,
  primaryButtonStyle,
  primaryButtonHandler,
  secondaryButtonText,
  secondaryButtonHandler,
  primaryButtonDisabled,
  secondaryButtonDisabled,
  secondaryButtonStyle,
  showBackButton,
  backButtonText,
  handleBackButton,
  containerClass,
}) => {

   const [otpFieldType,setOtpFieldType] = useState("password"); 
   const imagePrefix = config.envConfigs[config.env].imagePrefix;
   const otpShowHideToggle = () => {
     setOtpFieldType(otpFieldType ==="text" ? "password" : "text")
   };


  return (
    <CustomContainer className={`${styles["container"]} ${containerClass}`}>
      {showBackButton && (
        <ButtonWithIcon
          className={`${styles["back-button"]}`}
          labelText={backButtonText}
          img_url_inactive={`${imagePrefix}/assets/images/caret-back.svg`}
          img_url_active={`${imagePrefix}/assets/images/caret-back.svg`}
          img_url_disable={`${imagePrefix}/assets/images/disable-caret-back.svg`}
          clickHandler={handleBackButton}
          id={`checkout-upgrade-back`}
        />
      )}
      <p className={styles["title"]}>{title}</p>
      <OTPInput
        autoFocus
        isNumberInput
        length={6}
        className={styles["otpContainer"]}
        inputClassName={styles["otpInput"]}
        otpValues={otpValue}
        setOTPValues={otpHandler}
        otpFieldType ={otpFieldType}
        setOtpFieldType={setOtpFieldType}
      />
      <p className={styles["show-otp-container"]}> 
        <span>
          <img
            src={otpFieldType === "text" ? `${imagePrefix}/assets/images/hide.svg` : `${imagePrefix}/assets/images/show.svg`} alt="" width={20} height={20}
        />
        </span> 
        <CTAButton
            handleClick={otpShowHideToggle}
            variant={"flat teal51"}
            className={styles["show-otp"]}
        >
          {otpFieldType === "text" ? "Hide OTP" : "Show OTP"}
        </CTAButton>
      </p>
      {primaryButtonText && (
        <div className={styles.buttonContainer}>
          {primaryButtonText && (
            <CTAButton
              variant={primaryButtonStyle}
              className={`${styles["continueBtn"]}`}
              handleClick={primaryButtonHandler}
              disabled={primaryButtonDisabled}
            >
              {primaryButtonText}
            </CTAButton>
          )}
          {secondaryButtonText && (
            <CTAButton
              variant={secondaryButtonStyle}
              className={`${styles["continueBtn"]} py-0`}
              handleClick={() => secondaryButtonHandler(secondaryButtonText)}
              disabled={secondaryButtonDisabled}
            >
              {secondaryButtonText}
            </CTAButton>
          )}
        </div>
      )}
    </CustomContainer>
  );
};

export default OtpComponent;
